import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { WHITE, PRIMARY_LIGHT_BLUE } from "../colors";
import HeightBox from "../components/HeightBox";
import CustomerApplication from "../containers/Forms/CustomerApplicationV2";
import PoliceApplication from "../containers/Forms/PoliceApplications";
import CreateCandidateForm from "../containers/profile/form";
import { AddifatMarriedNoChildren } from "../containers/Forms/AddifatMarriedNoChildren";
import CustomerService from "../services/customerService";
import { match } from "react-router-dom";
import { removeURLParameter } from "../util/routeutils";
import {
  AFFIDAVIT_FORM,
  APPLICATION_FORM,
  POLICE_FORM,
  AFFIDAVIT_NOT_MARRIED,
  AFFIDAVIT_MARRIED_HAVE_CHILDREN,
  LETTER,
  LETTERENG,
  LETTERGEN,
  CANDIDATE_FORM,
} from "../constants/formTypes";

import { AffidatNotMarried } from "../containers/Forms/AffidatNotMarried";
import { AffidatMarriedHaveChildren } from "../containers/Forms/AffidavitMarriedHaveChildren";
import Letter from "../containers/Forms/Letter";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomers } from "../actions/customers";
import { Avatar, CardHeader } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LetterEng from "../containers/Forms/LetterEng"
import LetterGen from "../containers/Forms/LetterGen"


const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 42,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));

const FormSubmit = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const customerList = useSelector((state) => state.customerList);
  const { customers: customersStore } = customerList;
  const [applicationType, setApplicationType] = useState(APPLICATION_FORM);
  const [customerDefault, setCustomerDefault] = useState("NEW_CUSTOMER");

  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    customers: [],
    selectedCustomer: "",
    selectedCustomerFullDetails: params.customer
      ? customersStore?.find((customer) => parseInt(params.customer) === parseInt(customer.id))
      : null,
  });

  useEffect(() => {
    const getPageInfo = async () => {
      if (customersStore === null) {
        dispatch(getAllCustomers());
      }

      let customer = "";
      if (params.customer && params.type) {
        setApplicationType(params.type);
        customer = Number(params.customer);
      }
      setScreenInfo({
        ...screenInfo,
        customers: customersStore,
        searchedCustomers: customersStore,
        selectedCustomer: customer,
        selectedCustomerFullDetails: customersStore?.find(
          (customer) => parseInt(params.customer) === parseInt(customer.id)
        ),
      });
    };

    getPageInfo();
  }, []);

  useEffect(() => {
    if (applicationType === APPLICATION_FORM) {
      setCustomerDefault("NEW_CUSTOMER");
    } else {
      setCustomerDefault("SELECT_CUSTOMER");
    }
  }, [applicationType]);
  const removeQuery = () => {
    if (params.customer) {
      // let withoutCustomer = removeURLParameter(window.location.href, "customer");
      // withoutCustomer = removeURLParameter(withoutCustomer, "type");
      // window.location = withoutCustomer;
      window.history.replaceState({}, document.title, "/" + "form-submit");
    }
  };
  return (
    <div>
      <CreateCandidateForm />
    </div>
  );
};

export default FormSubmit;
